import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import PublicationAdminPanel from '../../../components/shared/PublicationAdminPanel.jsx';
import { fetchPublications, uploadPublication, updatePublication, deletePublication } from '../../../services/publicationsService.js';
import { useMeQuery } from '../../../services/authContext';

export default function Publications() {
  const { accounts, instance } = useMsal();
  const { isAdmin } = useMeQuery();
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFetchPublications = async () => {
    setLoading(true);
    setError(null);
    try {
      const pubs = await fetchPublications({ msalInstance: instance, account: accounts[0] });
      setPublications(pubs);
    } catch (err) {
      setError(err.message || 'Failed to fetch publications');
      setPublications([]);
    } finally {
      setLoading(false);
    }
  };

  const handleUploadPublication = async (values) => {
    setLoading(true);
    setError(null);
    try {
      await uploadPublication({ msalInstance: instance, account: accounts[0], ...values });
    } catch (err) {
      setError(err.message || 'Upload failed');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatePublication = async (pub, values) => {
    setLoading(true);
    setError(null);
    try {
      await updatePublication({ msalInstance: instance, account: accounts[0], pub, ...values });
    } catch (err) {
      setError(err.message || 'Update failed');
    } finally {
      setLoading(false);
    }
  };

  const handleDeletePublication = async (pub) => {
    setLoading(true);
    setError(null);
    try {
      await deletePublication({ msalInstance: instance, account: accounts[0], pub });
    } catch (err) {
      setError(err.message || 'Delete failed');
    } finally {
      setLoading(false);
    }
  };

  if (!isAdmin) {
    return <div style={{ color: 'red', margin: '2rem' }}>You do not have admin access to upload publications.</div>;
  }

  return (
    <PublicationAdminPanel
      fetchPublications={handleFetchPublications}
      uploadPublication={handleUploadPublication}
      updatePublication={handleUpdatePublication}
      deletePublication={handleDeletePublication}
      publications={publications}
      loading={loading}
      error={error}
    />
  );
}
